if (!customElements.get('rovel-bundle')) {
  customElements.define('rovel-bundle', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.cards = Array.from(this.querySelectorAll('.rovel-bundle__item'));
      this.enabled = this.dataset.enabled === 'true';
      this.sizeSelect = this.querySelector('[data-set-size]');
      this.submit = this.querySelector('button[type="submit"]');
      this.error = this.querySelector('[data-error]');
      this.money = new Intl.NumberFormat('ro-RO', {style: 'currency', currency: this.dataset.currency});
      this.querySelector('form').addEventListener('submit', event => this.add(event));
      try {
        const initial = JSON.parse(this.querySelector("[data-rovel-catalog]").textContent);
        this.products = initial.products;
        let url = initial.next;
        const seen = new Set();
        while (url) {
          const address = new URL(url, window.location.origin);
          if (address.origin !== window.location.origin || seen.has(address.href)) throw new Error('Invalid catalog pagination');
          address.searchParams.set('view', 'rovel-bundle-catalog');
          seen.add(address.href);
          const response = await fetch(address.href, {headers: {Accept: 'text/html'}, cache: 'no-store'});
          if (!response.ok) throw new Error('Catalog unavailable');
          const html = new DOMParser().parseFromString(await response.text(), "text/html");
          const page = JSON.parse(html.querySelector("[data-rovel-catalog]").textContent);
          this.products.push(...page.products);
          url = page.next;
        }
        if (!this.products.length) throw new Error('Empty catalog');
        this.products = Array.from(new Map(this.products.map(product => [String(product.id), product])).values());
        this.cards.forEach(card => {
          card.querySelector('[data-perfume]').addEventListener('change', () => this.updateCard(card));
        });
        this.sizeSelect.addEventListener('change', () => this.updateSize());
        this.updateSize();
      } catch (error) { console.error("ROVÉL catalog:", error); this.showError(this.labels.loadError); }
    }
    format(value) { return this.money.format(value / 100); }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    updateSize() {
      const size = this.sizeSelect.value;
      this.cards.forEach(card => {
        const select = card.querySelector('[data-perfume]');
        const previous = select.value;
        select.replaceChildren(new Option(this.labels.choose, ''));
        this.products.forEach(product => {
          const available = product.variants.some(variant => variant.size === size && variant.available);
          const option = new Option(product.title + (available ? '' : ' · ' + this.labels.unavailable), String(product.id));
          option.disabled = !available;
          select.add(option);
        });
        select.disabled = false;
        const retained = Array.from(select.options).find(option => option.value === previous && !option.disabled);
        select.value = retained ? previous : '';
        this.updateCard(card);
      });
    }
    updateCard(card) {
      const product = this.products.find(item => String(item.id) === card.querySelector('[data-perfume]').value);
      const size = this.sizeSelect.value;
      card.querySelector('[data-size]').textContent = size.replace('ml', ' ml');
      const variant = product?.variants.find(item => item.size === size && item.available);
      card.selectedVariant = variant || null;
      const image = card.querySelector('img');
      image.hidden = !variant?.image;
      card.querySelector('.rovel-bundle__photo span').hidden = Boolean(variant?.image);
      if (variant?.image) { image.src = variant.image; image.alt = product.title + ' · ' + variant.size.replace('ml', ' ml'); }
      card.querySelector('[data-price]').textContent = variant ? this.format(variant.price) : '—';
      this.updateSummary();
    }
    updateSummary() {
      const variants = this.cards.map(card => card.selectedVariant).filter(Boolean);
      const complete = variants.length === 5 && variants.every(variant => variant.size === this.sizeSelect.value);
      const subtotal = variants.reduce((sum, item) => sum + item.price, 0);
      const saving = complete ? Math.min(...variants.map(item => item.price)) : 0;
      this.querySelector('[data-progress]').textContent = complete ? this.labels.ready : variants.length + '/5 ' + this.labels.selected;
      this.querySelector('[data-subtotal]').textContent = variants.length ? this.format(subtotal) : '—';
      this.querySelector('[data-saving]').textContent = complete ? '−' + this.format(saving) : '—';
      this.querySelector('[data-total]').textContent = complete ? this.format(subtotal - saving) : '—';
      this.submit.disabled = !complete || !this.enabled;
      this.submit.textContent = this.enabled ? this.labels.add : this.labels.paused;
      this.cards.forEach(card => card.classList.remove('rovel-bundle__item--free'));
      if (complete) this.cards.find(card => card.selectedVariant.price === saving)?.classList.add('rovel-bundle__item--free');
    }
    async add(event) {
      event.preventDefault();
      const variants = this.cards.map(card => card.selectedVariant).filter(Boolean);
      if (!this.enabled || variants.length !== 5 || this.submit.disabled || !variants.every(variant => variant.size === this.sizeSelect.value)) return;
      this.submit.disabled = true;
      this.submit.textContent = this.labels.adding;
      this.error.hidden = true;
      const quantities = new Map();
      variants.forEach(variant => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: Array.from(quantities, ([id, quantity]) => ({id, quantity}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.labels.addError);
        window.location.assign(this.dataset.root + 'cart');
      } catch (error) {
        this.showError(error.message || this.labels.addError);
        this.submit.textContent = this.labels.add;
        this.updateSummary();
      }
    }
  });
}
